import { render, staticRenderFns } from "./RpdSavedQueriesDrawer.vue?vue&type=template&id=4989d09a"
import script from "./RpdSavedQueriesDrawer.vue?vue&type=script&lang=js"
export * from "./RpdSavedQueriesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports